import { useABTestStore } from '../../store';

const useAB = (testName) => {
  const { abTests } = useABTestStore(['abTests']);

  return abTests[testName];
};

export default useAB;
